import {TITLES} from "../../types/GridTypes";

export enum FILTER_FAMILY {
  DESTINATION = 'Destination',
  DATE = 'Date',
  NUMBER_OF_MATCHES = 'Number of matches',
  PRICE = 'Price',
  ARRIVAL_TYPE = 'Arrival Type',
  DURATION = 'Duration bucket',
  SEATS = 'Seats on aircraft',
}
export enum FILTER_OPERATOR {
  STRING = 'string',
  NUMBER = 'number',
  DATE = 'date',
  BOOLEAN = 'boolean',
  SELECT = 'select',
}

export enum FILTER_FIELD {
  DEST_COUNTRY = 'Destination-country',
  DEST_CITY = 'Destination-city',
  DEST_AIRPORT = 'Destination-airport',

  MONTH_DUE_DATE = 'Month of due date',
  DAYS_AHEAD_FLIGHT = 'Days ahead of flight',

  NUM_OF_MATCHES = 'Number of matches',

  MY_PRICE = 'My price',
  HIGHER_THAN_ALL = 'Higher than all competitors',
  LOWER_THAN_ALL = 'Lower than all competitors',
  PRICE_CHANGED_LATELY = 'Price changed lately',
  PRICE_IS_HIGHER_THAN_COMPETITOR = 'Price is higher than competitors',
  PRICE_IS_LOWER_THAN_COMPETITOR = 'Price is lower than competitors',
  PRICE_GROUPS = 'Price groups',

  HOME_BASE_TO = 'Home base to',
  ORIGIN_TO_HOME_BASE = 'Origin to home base',

  ARRIVAL_TYPE = 'Arrival type',
  DURATION_BUCKET = 'Duration bucket',
  SEATS_ON_AIRCRAFT = 'Seats on aircraft',
}

export const COMPETITORS = [
  'British AW',
  'Easy Jet',
  'WIZZ-air',
  'Ryanair',
  'Blue Air',
  'Thai AW',
];
export const intialFilters = {
  [FILTER_FAMILY.DESTINATION]: [
    {
      field: FILTER_FIELD.DEST_COUNTRY,
      operator: FILTER_OPERATOR.STRING,
      value: null,
      operatorValue: 'eq'
    },
    {
      field: FILTER_FIELD.DEST_CITY,
      operator: FILTER_OPERATOR.STRING,
      value: null,
      operatorValue: 'eq'
    },
    {
      field: FILTER_FIELD.DEST_AIRPORT,
      operator: FILTER_OPERATOR.STRING,
      value: null,
      operatorValue: 'eq'
    },
    {
      field: FILTER_FIELD.HOME_BASE_TO,
      operator: FILTER_OPERATOR.STRING,
      isSpecial: true,
      value: null,
      operatorValue: 'eq'
    },
    {
      field: FILTER_FIELD.ORIGIN_TO_HOME_BASE,
      operator: FILTER_OPERATOR.STRING,
      isSpecial: true,
      value: null,
      operatorValue: 'eq'
    },
  ],
  [FILTER_FAMILY.DATE]: [
    {
      field: FILTER_FIELD.MONTH_DUE_DATE,
      operator: FILTER_OPERATOR.NUMBER,
      value: null,
      isSpecial: true,
      operatorValue: 'eq'
    },
    {
      field: FILTER_FIELD.DAYS_AHEAD_FLIGHT,
      operator: FILTER_OPERATOR.NUMBER,
      value: null,
      isSpecial: true,
      operatorValue: 'eq'
    },
  ],
  [FILTER_FAMILY.NUMBER_OF_MATCHES]: [
    {
      field: FILTER_FIELD.NUM_OF_MATCHES,
      operator: FILTER_OPERATOR.NUMBER,
      value: null,
      operatorValue: 'eq'
    },
  ],
  [FILTER_FAMILY.PRICE]: [
    {
      field: FILTER_FIELD.MY_PRICE,
      operator: FILTER_OPERATOR.NUMBER,
      value: null,
      operatorValue: 'eq'
    },
    {
      field: FILTER_FIELD.HIGHER_THAN_ALL,
      operator: FILTER_OPERATOR.BOOLEAN,
      value: null,
      disabled: true,
      isSpecial: true,
    },
    {
      field: FILTER_FIELD.LOWER_THAN_ALL,
      operator: FILTER_OPERATOR.BOOLEAN,
      value: null,
      disabled: true,
      isSpecial: true,
    },
    {
      field: FILTER_FIELD.PRICE_CHANGED_LATELY,
      operator: FILTER_OPERATOR.BOOLEAN,
      value: null,
      disabled: true,
    },
    {
      field: FILTER_FIELD.PRICE_IS_HIGHER_THAN_COMPETITOR,
      operator: FILTER_OPERATOR.STRING,
      value: null,
      disabled: true,
      isSpecial: true,
      operatorValue: 'eq'
    },
    {
      field: FILTER_FIELD.PRICE_IS_LOWER_THAN_COMPETITOR,
      operator: FILTER_OPERATOR.STRING,
      value: null,
      disabled: true,
      isSpecial: true,
      operatorValue: 'eq'
    },
    {
      field: FILTER_FIELD.PRICE_GROUPS,
      operator: FILTER_OPERATOR.SELECT,
      value: null,
      isSpecial: true,
      operatorValue: 'Between',
      valueOptions: ['','0-100','100-200', '200-300', '300-400', '400-500', '500-600', '600-700', '700-1000', '1000+','0-1000'],
      placeholder:'e.g. "100-200" (in $)'
    },
  ],
  [FILTER_FAMILY.ARRIVAL_TYPE]: [
    {
      field: FILTER_FIELD.ARRIVAL_TYPE,
      operator: FILTER_OPERATOR.SELECT,
      valueOptions: ['Morning', 'After-noon', 'Evening', 'Night', 'After-midnight'],
      value: null,
      operatorValue: 'eq'
    },
  ],
  [FILTER_FAMILY.DURATION]: [
    {
      field: FILTER_FIELD.DURATION_BUCKET,
      operator: FILTER_OPERATOR.SELECT,
      valueOptions: ['1-4', '4-8', '8+'],
      value: null,
      isSpecial: true,
      operatorValue: 'eq'
    },
  ],
  [FILTER_FAMILY.SEATS]: [
    {
      field: FILTER_FIELD.SEATS_ON_AIRCRAFT,
      operator: FILTER_OPERATOR.NUMBER,
      value: null,
      disabled: true,
      isSpecial: true,
      operatorValue: 'eq'
    },
  ],
};

export const FILTER_TO_TITLES: { [key in FILTER_FIELD]: TITLES } = {
  [FILTER_FIELD.DEST_COUNTRY]: TITLES.DESTINATION_COUNTRY,
  [FILTER_FIELD.DEST_CITY]: TITLES.DESTINATION_CITY,
  [FILTER_FIELD.DEST_AIRPORT]: TITLES.DESTINATION_AIRPORT,
  [FILTER_FIELD.MONTH_DUE_DATE]: TITLES.FLIGHT_DUE_DATE,
  [FILTER_FIELD.DAYS_AHEAD_FLIGHT]: TITLES.DEPARTURE_TIME, // Assuming 'Days ahead of flight' corresponds to 'Departure time'
  [FILTER_FIELD.NUM_OF_MATCHES]: TITLES.FLIGHT_ID, // Assuming 'Number of matches' corresponds to 'Flight ID'
  [FILTER_FIELD.MY_PRICE]: TITLES.MY_PRICE,
  [FILTER_FIELD.HIGHER_THAN_ALL]: TITLES.PRICE_VS_MARKET, // Assuming 'Higher than all competitors' corresponds to 'Price Vs. Market'
  [FILTER_FIELD.LOWER_THAN_ALL]: TITLES.PRICE_VS_MARKET, // Assuming 'Lower than all competitors' corresponds to 'Price Vs. Market'
  [FILTER_FIELD.PRICE_CHANGED_LATELY]: TITLES.LAST_SCAN, // Assuming 'Price changed lately' corresponds to 'Last Scan'
  [FILTER_FIELD.PRICE_IS_HIGHER_THAN_COMPETITOR]: TITLES.PRICE_VS_MARKET, // Assuming 'Price is higher than competitors' corresponds to 'Price Vs. Market'
  [FILTER_FIELD.PRICE_IS_LOWER_THAN_COMPETITOR]: TITLES.PRICE_VS_MARKET, // Assuming 'Price is lower than competitors' corresponds to 'Price Vs. Market'
  [FILTER_FIELD.PRICE_GROUPS]: TITLES.MY_PRICE, // Assuming 'Price groups' corresponds to 'My Price'
  [FILTER_FIELD.HOME_BASE_TO]: TITLES.ORIGIN_AIRPORT, // Assuming 'Home base to' corresponds to 'Origin Airport'
  [FILTER_FIELD.ORIGIN_TO_HOME_BASE]: TITLES.DESTINATION_AIRPORT, // Assuming 'Origin to home base' corresponds to 'Destination Airport'
  [FILTER_FIELD.ARRIVAL_TYPE]: TITLES.ARRIVAL_TYPE,
  [FILTER_FIELD.DURATION_BUCKET]: TITLES.FLIGHT_DURATION,
  [FILTER_FIELD.SEATS_ON_AIRCRAFT]: TITLES.AIRCRAFT, // Assuming 'Seats on aircraft' corresponds to 'Aircraft'
};